import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { parse } from '../../util/urlHelpers';
import { CREDITS_PACKAGE_1, CREDITS_PACKAGE_2, CREDITS_PACKAGE_3 } from '../../credits-config';
import { SEARCH_PARAM_PACKAGE_KEY } from './BalancePage';

export const useInitialPackageFromSearchParam = ({ setModalOpen }) => {
    const history = useHistory();
    const [selectedPackage, setSelectedPackage] = useState(CREDITS_PACKAGE_1);

    const searchParamsParsed = parse(history.location.search);
    const packageFromSearchParamsSelected = searchParamsParsed[SEARCH_PARAM_PACKAGE_KEY];

    useEffect(() => {
        if (!packageFromSearchParamsSelected) return;
        if (
            packageFromSearchParamsSelected !== CREDITS_PACKAGE_1 &&
            packageFromSearchParamsSelected !== CREDITS_PACKAGE_2 &&
            packageFromSearchParamsSelected !== CREDITS_PACKAGE_3
        )
            return;

        setSelectedPackage(packageFromSearchParamsSelected);
        setModalOpen(true);
    }, [packageFromSearchParamsSelected]);

    return selectedPackage;
};
